import React from "react";

// Import logos from local assets (adjust the paths as per your project structure)
import volkswagen from "../Assest/volkswagen_logo.png";
import southIndBank from "../Assest/south-ind-bank-logo.png";
import werize from "../Assest/werize-logo.png";
import saraswat from "../Assest/Saraswat-bank-logo.png";
import homeCredit from "../Assest/Home_Credit_logo.png";
import hdfc from "../Assest/HDFC-Bank-logo.png";

const logos = [
  volkswagen,
  southIndBank,
  werize,
  saraswat,
  homeCredit,
  hdfc,
];

const LogoSlider = () => {
  const headingStyle = {
    textAlign: "center",
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "10px",
    color: "#000",
    fontFamily: "Arial, sans-serif",
  };

  const subheadingStyle = {
    textAlign: "center",
    fontSize: "16px",
    marginBottom: "30px",
    color: "#555",
    fontFamily: "Arial, sans-serif",
  };

  const wrapperStyle = {
    overflow: "hidden",
    width: "100%",
    backgroundColor: "#f8f8f8",
    padding: "20px 0",
  };

  const sliderTrackStyle = {
    display: "flex",
    width: `${logos.length * 2 * 200}px`,
    animation: "scroll 25s linear infinite",
  };

  const slideStyle = {
    width: "200px",
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const imageStyle = {
    width: "100%",
    height: "auto",
    maxHeight: "60px",
    objectFit: "contain",
    filter: "grayscale(100%)",
    transition: "filter 0.3s ease-in-out",
  };

  return (
    <>
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .logo-slide img:hover {
            filter: grayscale(0%);
          }
        `}
      </style>

      <div style={{ background: "#f8f8f8", padding: "40px 20px" }}>
        <h2 style={headingStyle}>Om Sai Credit Collection</h2>
        <p style={subheadingStyle}>
          Catering more than 21 portfolios of Banks & NBFCs and many more to come
        </p>

        <div style={wrapperStyle}>
          <div style={sliderTrackStyle}>
            {logos.concat(logos).map((logo, index) => (
              <div style={slideStyle} key={index} className="logo-slide">
                <img src={logo} alt={`Logo ${index + 1}`} style={imageStyle} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default LogoSlider;
